import * as h2Api from '../h2Api'
import * as personalProfileActions from '../actions/personalProfile'

const initialState = {
  profile: null,
  profileUserNameInDialog: {
    name: '',
    about: ''
  },
  recommendations: {
    status: null,
    feed: [],
    companies: []
  },
  bookmarks: [],
  steps: [],
  flags: [],
  files: [],
  journals: [],
  plans: [],
  schedule: [],
  assessmentStatus: { status: null, result: {} },
  upcomingEvents: [],
  isPublicProfilePopupOpened: false
}
const personalProfile = (state = initialState, action) => {
  const mapSlotWithRestResult = emptyValue => {
    return {
      status: action.restCall.status,
      result:
        action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED
          ? action.restCall.result
          : emptyValue
    }
  }

  switch (action.type) {
    case personalProfileActions.FETCH_RECOMMENDATIONS:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const result = action.restCall.result

        return {
          ...state,
          recommendations: {
            status: true,
            feed: result.feed || [],
            companies: result.companies || []
          }
        }
      }

      return state

    case personalProfileActions.FETCH_ASSESSMENT_STATUS:
      return { ...state, assessmentStatus: mapSlotWithRestResult([]) }

    case personalProfileActions.FETCH_UPCOMING_EVENTS:
      return { ...state, upcomingEvents: mapSlotWithRestResult([]) }

    case personalProfileActions.OPEN_OR_CLOSE_ACTIVATE_PUBLIC_PROFILE_DIALOG:
      return { ...state, isPublicProfilePopupOpened: action.isOpened }

    case personalProfileActions.PROFILE_USERNAME_CHANGE_IN_DIALOG:
      const newFieldValues = { ...state.profileUserNameInDialog, ...action.value }

      return { ...state, profileUserNameInDialog: newFieldValues }

    case personalProfileActions.ADD_ASSESSMENT_SECTION:
      return { ...state }

    case personalProfileActions.ACTIVATE_PUBLIC_PROFILE:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          profile: {
            ...state.profile,
            publicProfileUrl: action.restCall.result.url
          }
        }
      }

      return state

    case personalProfileActions.PROFILE_SELECT_STEP:
      return {
        ...state,
        steps: {
          ...state.steps,
          current: action.step
        }
      }

    case personalProfileActions.TOGGLE_SECTION_PUBLICATION:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          steps: {
            ...state.steps,
            items: action.restCall.result.steps
          }
        }
      }

      return state

    case personalProfileActions.FETCH_COMBINED_INFO_FOR_PERSONAL_PROFILE_SCREEN:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const result = action.restCall.result

        return {
          ...state,
          assessmentStatus: result.assessmentStatus,
          profile: result.profile,
          recommendations: {
            status: !result.recommendations.hasOwnProperty('error'),
            feed: result.recommendations.feed || [],
            companies: result.recommendations.companies || []
          },
          bookmarks: result.bookmarks,
          steps: result.steps,
          files: result.files,
          flags: result.flags,
          journals: result.journals,
          plans: result.plans,
          schedule: result.schedule,
          upcomingEvents: result.upcomingEvents || []
        }
      }

    default:
      return state
  }
}

export default personalProfile
